import React, { useEffect } from 'react'

const Faqs = () => {
    useEffect(() => {
        window.scroll(0,0)


    }, [])

    return (
        <div className="flex items-center justify-center">
            Frequently Asked Questions
        </div>
    )
}

export default Faqs
